var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createpackage"},[_c('NavBar'),_c('h1',[_vm._v("Add New Contract")]),_c('CompAddContract'),_c('UserCheck'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }